import { maxVisibleSharedGroups } from './constants'

export const getSelectedGroups = (groups, selectedGroupIds) => {
  return groups.filter(group => selectedGroupIds.includes(group.id))
}

export const getSharedGroupsSummary = groups => {
  const visibleGroups = groups.slice(0, maxVisibleSharedGroups)

  return {
    count: groups.length,
    visibleNames: visibleGroups.map(group => group.name),
    hiddenCount: groups.length - visibleGroups.length,
  }
}
